export default __webpack_public_path__ + "7f2456e.png";